<template>
  <div class="dialog-jd-tool-wrapper">
    <el-dialog width="30%" :title="`京东商户工具（${merchant.merchant_id}）`" :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <h4 style="margin-top: 0">微信商户号： {{ wxNo }}</h4>

      <el-form label-position="top" ref="form" :rules="formRules" :model="formData">
        <el-form-item label="对账单时间" prop="date">
          <el-date-picker
            v-model="formData.date"
            type="date"
            style="width: 100%;"
            placeholder="选择对账单时间">
          </el-date-picker>
        </el-form-item>

        <div class="submit-wrapper">
          <el-button
            type="danger"
            size="medium"
            @click="onBillDownload">下载对账单</el-button>
          <el-button
            size="medium"
            @click="onFormCancel">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import bankApi from '@/api/bankApi'

export default {
  name: 'DialogJdTool',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    merchant: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      wxNo: 'Unknown',
      formData: {
        date: ''
      },
      formRules: {
        date: [
          { required: true, message: '选择对账单时间', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    async queryWxNo () {
      try {
        const res = await bankApi.queryWxNo(this.merchant.merchant_id)
        if (res.data.hlbWxSubNoResultInfoData.threePartnerNoData.length > 0) {
          this.wxNo = res.data.hlbWxSubNoResultInfoData.threePartnerNoData[0].threePartnerNo
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: '查询微信商户号失败'
        })
        console.log(err)
      }
    },
    async downloadBill () {
      const loading = this.$loading({
        lock: true,
        text: '正在下载对账单，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      })
      try {
        const res = await bankApi.downloadBill(this.merchant.merchant_id, this.formData.date)
        if (res.data.path !== '') {
          this.saveFile(res.data.path)
        }
        this.$emit('update:visible', false)
      } catch (err) {
        this.$message({
          type: 'error',
          message: '下载对账单失败'
        })
        console.log(err)
      }
      loading.close()
    },
    async onBillDownload () {
      try {
        await this.$refs['form'].validate()

        this.downloadBill()
      } catch (err) {
        console.log(err)
      }
    },
    onFormCancel () {
      this.$emit('update:visible', false)
    },

    // 下载文件
    saveFile (data) {
      const saveLink = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
      saveLink.href = data
      var event = document.createEvent('MouseEvents')
      event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
      saveLink.dispatchEvent(event)
    },

    onDialogOpen () {
      this.formData.date = new Date()
      this.queryWxNo()
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-jd-tool-wrapper {

  .submit-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bank/DialogJdTool.vue